import styled from "styled-components";

export const TableContainer = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  overflow: "hidden",
}));

export const Table = styled("table")(({ theme, minWidth, isClickableRow }) => ({
  borderCollapse: "separate",
  borderSpacing: 0,
  width: "100%",
  maxWidth: "100%",
  position: "relative",
  backgroundColor: "#fff",
  tableLayout: "fixed",
  boxSizing: "border-box",

  "& thead > tr": {
    backgroundColor: "#f8f9fa",
    borderBottom: "1px solid #e5e8eb",
  },

  "& th": {
    padding: "16px 12px",
    fontWeight: 600,
    color: "#4a5568",
    textAlign: "left",
    fontSize: 12,
    textTransform: "capitalize",
    letterSpacing: "0.3px",
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",

    "&:first-child": {
      paddingLeft: 20,
      borderTopLeftRadius: 8,
    },

    "&:last-child": {
      paddingRight: 20,
      borderTopRightRadius: 8,
    },

    "@media (max-width: 768px)": {
      padding: "14px 10px",
      fontSize: 11,
      whiteSpace: "normal",

      "&:first-child": {
        paddingLeft: 14,
      },

      "&:last-child": {
        paddingRight: 14,
      },
    },

    "@media (max-width: 460px)": {
      padding: "12px 8px",
      fontSize: 10,
    },
  },

  "& tbody > tr": {
    backgroundColor: "#fff",
    borderBottom: "1px solid #e5e8eb",
    transition: "background-color 0.15s ease",
    
    "&:last-child": {
      borderBottom: "none",
      
      "& td:first-child": {
        borderBottomLeftRadius: 8,
      },
      
      "& td:last-child": {
        borderBottomRightRadius: 8,
      },
    },
    
    ...(isClickableRow ? ({
      "&:hover": {
        backgroundColor: "#f8f9fb",
        cursor: "pointer",
      }
    }) : {
      "&:hover": {
        backgroundColor: "#f8f9fb",
      }
    }),
  },

  "& td": {
    padding: "16px 12px",
    fontSize: 14,
    color: "#2d3748",
    verticalAlign: "top",
    wordBreak: "break-word",
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",

    "&:first-child": {
      paddingLeft: 20,
    },

    "&:last-child": {
      paddingRight: 20,
    },

    "@media (max-width: 768px)": {
      padding: "14px 10px",
      fontSize: 13,

      "&:first-child": {
        paddingLeft: 14,
      },

      "&:last-child": {
        paddingRight: 14,
      },
    },

    "@media (max-width: 460px)": {
      padding: "12px 8px",
      fontSize: 12,
    },
  }
}));

export const PaginationBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 12,
  marginTop: 32,
  padding: "20px 0",
}));

export const PaginationButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  backgroundColor: "#1976d2",
  color: "#fff",
  border: "none",
  padding: 0,
  width: 40,
  height: 40,
  borderRadius: 8,
  fontSize: 20,
  cursor: "pointer",
  transition: "all 0.2s ease",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",

	"&:hover:not(:disabled)": {
		backgroundColor: "#1565c0",
    transform: "translateY(-1px)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
	},

  "&:active:not(:disabled)": {
    transform: "translateY(0)",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
  },

  "&:disabled": {
    backgroundColor: "#bdbdbd",
    cursor: "not-allowed",
    opacity: 0.6,
  },
}));

export const PageNumberButton = styled("button")(({ theme, active }) => ({
  ...theme.mixins.flexCenterCenter,
  backgroundColor: active ? "#1976d2" : "#fff",
  color: active ? "#fff" : "#333",
  border: active ? "none" : "1px solid #e0e0e0",
  padding: 0,
  width: 40,
  height: 40,
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  transition: "all 0.2s ease",
  boxShadow: active ? "0 2px 4px rgba(0, 0, 0, 0.1)" : "none",

  "&:hover:not(:disabled)": {
    backgroundColor: active ? "#1565c0" : "#f5f5f5",
    borderColor: active ? "transparent" : "#bdbdbd",
  },

  "&:active:not(:disabled)": {
    transform: "scale(0.95)",
  },

  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.6,
  },
}));

export const PaginationInfo = styled("div")(({ theme }) => ({
  textAlign: "center",
  fontSize: 14,
  color: "#666",
  marginTop: 20,
  fontWeight: 500,
}));
